import { gql } from 'apollo-angular';

/**
 * Order schema
 */
export class LabLockSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		activationDate
		dentist {
			billingAddress {
				address1
				address2
				city
				zipCode
			}
			eMailAddress
			name
			phoneNumber
			uid
		}
		inventoryNumber
		lab {
			billingAddress {
				address1
				address2
				city
				zipCode
			}
			eMailAddress
			name
			phoneNumber
			uid
		}
		labLockState
		uid
		workstationId
	`;

	/**
	 * Accept LabLock
	 */
	static readonly acceptLabLock = gql`
		mutation AcceptLabLock($activationCode: String!) {
			acceptLabLock(activationCode: $activationCode) {
				${LabLockSchema.topLevelProperties}
			}
		}
	`;

	/**
	 * Add LabLock entry
	 */
	static readonly addLabLockEntry = gql`
		mutation AddLabLockEntry($workstationId: String!, $inventoryNumber: String!, $dentistUserName: String!) {
			addLabLockEntry(workstationId: $workstationId, inventoryNumber: $inventoryNumber, dentistUserName: $dentistUserName)
		}
	`;

	/**
	 * Deactivate LabLock
	 */
	static readonly deactivateLabLock = gql`
		mutation DeactivateLabLock($labLockEntryUid: ID!) {
			deactivateLabLock(labLockEntryUid: $labLockEntryUid)
		}
	`;
}
